<template>
  <div class="rootDiv">
    <Cell :title="item.qZMC" v-for="item in circleList" :key="item.qZNM" style="text-align: left"
          v-on:click.native="Details(item.qZNM)">
      <avatar slot="icon" class="avatar" username="Birth Circle"
              :src="item.qZTB"
              :size="48">
      </avatar>
      <div slot="title" style="float: left;width: 85%">
        <div style="float: left;">
          <div>
            <span class="titleClass">{{ item.qZMC }}</span>
            <span style="font-size: 0.6rem;margin-left: 10px">({{ item.qZHM }})</span>
          </div>
          <div class="infoClass">
            <span>创建人:</span>
            <span style="color: forestgreen">{{ item.creator }}</span>
            <span style="margin-left: 10px">生日个数:</span>
            <span style="color: forestgreen">{{ item.birthCount }}</span>
            <span>个</span>
          </div>
        </div>
        <div v-if="item.nearBirthCount>0" style="float: right;text-align: right;padding-top: 15px;">
          <Badge :content="item.nearBirthCount" max="9" color="red"/>
        </div>
        <div style="clear: both"></div>
      </div>
    </Cell>
    <div class="empty-div">
      <div>
        <img src="../../../assets/images/no_data.png" v-if="showEmptyImage" alt=""/>
      </div>
    </div>
    <PaletteButton :offset="20" :radius="80" content="+"
                   style="position: fixed;right: 10px;bottom:70px"
                   mainButtonStyle="color:green;background-color:#2ee1bd;" @expand="Expanded()"
                   @collapse="Collapse()">
      <div class="my-icon-button"
           :style="{'visibility':PaletteButtonVisibility}"
           @touchstart="CreateCircle()"><span>创建</span></div>
      <div class="my-icon-button"
           :style="{'visibility':PaletteButtonVisibility}"
           @touchstart="AddCircle()"><span>加入</span></div>
    </PaletteButton>
  </div>
</template>

<script>

import {Cell, PaletteButton} from "mint-ui";
import Avatar from 'vue-avatar'
import {Badge} from 'vant';
import 'vant/lib/badge/index.css'

export default {
  name: "CirclePage",
  components: {
    Cell, PaletteButton, Avatar, Badge
  },
  data() {
    return {
      showEmptyImage: false,
      PaletteButtonVisibility: 'collapse',
      circleList: [],
      circleModel: {
        birthCount: 0,
        userCount: 0,
        nearBirthCount: 0,
        creator: '',
        administrator: '',
        cJSJ: null,
        cJYHNM: null,
        qZGLY: null,
        qZHM: null,
        qZJJ: '',
        qZMC: '',
        qZNM: null,
        qZTB: null
      },
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getCircleListUrl: '/api/circle/getCircleList',
    }
  },
  mounted() {
    this.getCircleList()
  },
  methods: {
    Expanded() {
      this.PaletteButtonVisibility = 'visible'
    },
    Collapse() {
      this.PaletteButtonVisibility = 'collapse'
    },
    CreateCircle() {
      this.$router.push('/m_create_circle')
    },
    AddCircle() {
      this.$router.push('/m_add_circle')
    },
    Details(qznm) {
      this.$router.push({name: 'm_circle_birthday', query: {qznm: qznm, isManagerPage: '0'}})
    },
    getCircleList() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getCircleListUrl,
        params: {yhnm: that.yhnm},
        headers: {token: that.token}
      }).then((response) => {
        if (response.data.result) {
          that.circleList = response.data['responseData']
          that.showEmptyImage = that.circleList.length === 0
          that.circleList.forEach(item => {
            if (item.qZTB == null) {
              const data = require('/public/config/data.json')
              item.qZTB = data['defaultGroupUrl']
            }
          })
        } else {
          that.$messagebox.alert(response.data.message)
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
}

/deep/ .mint-cell-title {
  border-bottom: 1px solid gainsboro;
  padding-bottom: 2px;
  padding-top: 2px;
}

/deep/ .vue-avatar--wrapper {
  float: left;
}

.titleClass {
  line-height: 25px;
  font-size: 1.2rem;
  margin-left: 0.5rem;
  color: #2986de;
}

.infoClass {
  margin-left: 0.5rem;
  padding-top: 0.3rem;

  span {
    font-size: 0.8rem;
  }
}

.empty-div {
  position: absolute;
  left: 55%;
  top: 40%;
  transform: translate3d(-50%, -50%, 0);
}

.my-icon-button {
  background-color: #72d878;
  text-align: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
